import { render, staticRenderFns } from "./FormControlOdpCourseDatesCourseId.vue?vue&type=template&id=2a28ca60"
import script from "./FormControlOdpCourseDatesCourseId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlOdpCourseDatesCourseId.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports